import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import MessageTable from './message-table';
import FilterList from './filter-list';
import SummaryHeader from './summary-header';
import Stack from '@mui/material/Stack';

function MessageViewerContainer() {
  const [currentAppFilter, setCurrentAppFilter] = useState('');
  const [messageSummary, setMessageSummary] = useState({});

  return (
    <Stack spacing={2}>
      <SummaryHeader messageSummary={messageSummary} />
      <Grid container justifyContent="center" spacing={2}>
        <Grid item>
          <Paper elevation={2}>
            <FilterList setCurrentAppFilter={setCurrentAppFilter} />
          </Paper>
        </Grid>
        <Grid item xs>
          <Paper elevation={2}>
            <MessageTable
              currentAppFilter={currentAppFilter}
              setMessageSummary={setMessageSummary}
            />
          </Paper>
        </Grid>
      </Grid>
    </Stack>
  );
}

export default MessageViewerContainer;
